import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "../assets/scss/componnetScss/ourClient.module.scss"; // Custom SCSS for styling

const clients = [
    { id: 1, name: "Cloudnine", img: "/images/client/1.png" },
    { id: 2, name: "Ather", img: "/images/client/2.png" },
    { id: 3, name: "Cliff", img: "/images/client/3.png" },
    { id: 4, name: "Sinch", img: "/images/client/4.png" },

];

const ClientCarousel = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4, // Adjust for mobile responsiveness
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <section className={styles.client_carousel}>
            <div className="container">
                <div >
                    <h3>We work with 200+ businesses to provide the best services.</h3>
                    <Slider {...settings}>
                        {clients.map((client) => (
                            <div key={client.id} className={styles.client_logo}>
                                <img src={client.img} alt={client.name} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default ClientCarousel;
